/**
 * Enum tampilan & setting album. Di-import langsung oleh web (web/src/lib/theme.ts),
 * jadi file ini hanya boleh berisi konstanta dan tipe, tanpa import runtime Worker.
 */
export const FILM_KEYS = ["portra800", "cinestill800t", "hp5", "ultramax400"] as const;

export const SETTINGS_ENUMS = {
  event_type: ["wedding", "birthday", "baby_shower", "travel", "corporate", "other"],
  camera: ["analogue", "instant"],
  instant_format: ["mini", "square", "wide"],
  visibility: ["all", "own"],
} as const;

type E = typeof SETTINGS_ENUMS;
export type Settings = {
  event_type: E["event_type"][number];
  camera: E["camera"][number];
  instant_format?: E["instant_format"][number]; // wajib jika camera=instant
  visibility: E["visibility"][number];
  likes: boolean;
  comments: boolean;
};

/** Album lama (settings NULL) dibaca sebagai polaroid persegi, tanpa like/comment. */
export const DEFAULT_SETTINGS: Settings = {
  event_type: "other",
  camera: "instant",
  instant_format: "square",
  visibility: "all",
  likes: false,
  comments: false,
};
